var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "25a022g04a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.662745 0 0 0 0 0.670588 0 0 0 0 0.674510 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#E36510",
    strokeWidth: 2,
    filter: "url(#25a022g04a)",
    transform: "translate(-543 -1270) translate(172 1270) translate(372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.444 16.889h8.974c2.286 0 5.659-.909 5.357-4.478-.32-3.775-4.35-3.71-5.118-1.6-.48 1.319.128 2.431 1.212 2.495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.444 20.444h17.863c2.285 0 5.659-.908 5.357-4.478-.32-3.774-4.35-3.71-5.118-1.599-.48 1.318.128 2.43 1.212 2.495M8.444 23.588h8.974c2.286 0 5.659.908 5.357 4.478-.32 3.774-4.35 3.71-5.118 1.6-.48-1.319.128-2.431 1.212-2.495"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindIcon);
export default __webpack_public_path__ + "static/media/wind-icon.b6a4df62de5b4719e835e37ab1bef4e2.svg";
export { ForwardRef as ReactComponent };